exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.seeker-name-highlight[data-v-6a2c68f3] {\n  background-color: #f0f8ff;\n  color: #AA0066;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #e1e8ed;\n  display: inline-block;\n  margin-left: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a2c68f3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/emails/MailActionContent.vue
// module id = XXbW
// module chunks = 3